import React, { useState } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import CustomerSetup from "../../License/CustomerSetup/CustomerSetup";
import CustomSwitch from "../../../components/Elements/CustomSwitch/CustomSwitch";
import { API_URLS } from "../../../api/apiUrls";
import { putApi } from "../../../api/api_instance";

const CustomerSetupDetails = ({ clientId }) => {
  const [value, setValue] = useState(null); // should be boolean

  const handleToggleAccess = async (newValue) => {
    
    try {
      const response = await putApi({
        apiUrl: API_URLS.PUT_CUSTOMER_UPDATE_ACCESS(clientId),
        data: { status: newValue },
      });

      console.log("Updated successfully:", response);
    } catch (error) {
      console.error("Failed to update access", error);
    }
  };

  return (
    <div className="px-[40px] pt-2 mt-3">
      <CardsBorder>
        <div>
          <div className="mx-8 font-semibold text-[17px] flex justify-between">
            <p>Customer Setup Details</p>

            {/* Value will be true/false from API */}
           <div className="font-sm text-[17px]">
            <p>Blur/Unblur</p>
            <CustomSwitch
              checked={value} // set switch UI
              onChange={(checked) => {
                setValue(checked);      // update local UI state
                handleToggleAccess(checked);  // call API with updated value
              }}
            />
            </div>
          </div>

          <CustomerSetup
            clientId={clientId}
            value={value}
            setValue={setValue}
          />
        </div>
      </CardsBorder>
    </div>
  );
};

export default CustomerSetupDetails;
